/**
 * Listing CreatedAt filter: calendar dates from the UI are interpreted as
 * Istanbul (Europe/Istanbul) civil days and converted to UTC ISO bounds for the API.
 */
const IST_OFFSET = '+03:00';

export function istanbulCalendarDayStartUtcIso(isoDateYmd: string): string {
  return new Date(`${isoDateYmd}T00:00:00.000${IST_OFFSET}`).toISOString();
}

export function istanbulCalendarDayEndUtcIso(isoDateYmd: string): string {
  return new Date(`${isoDateYmd}T23:59:59.999${IST_OFFSET}`).toISOString();
}

export function istanbulDateRangeToCreatedAtBoundary(isoFrom: string, isoTo: string): {
  lowerBound: string;
  upperBound: string;
} {
  return {
    lowerBound: istanbulCalendarDayStartUtcIso(isoFrom),
    upperBound: istanbulCalendarDayEndUtcIso(isoTo),
  };
}
